import { NAVIGATION } from '../constants/action_types';

const initialState = { location: '' };

export default function (state = initialState, action) {
    switch (action.type) {
        case NAVIGATION:
            return { location: action.payload};
        default:
            return state;
    }
}